export default "__VITE_ASSET__CDSyVpAw__"